import { Pane, Heading, Paragraph, UnorderedList, ListItem } from 'evergreen-ui';

const TermsPage = () => {
  return (
    <Pane padding={24} background="tint1">
      <Heading size={800} marginBottom={16}>Termini e Condizioni</Heading>

      <Paragraph size={400} marginBottom={12}>
        Benvenuto su Casa Letizia. I presenti termini e condizioni regolano l'accesso e l'utilizzo dei servizi offerti tramite questo sito.
      </Paragraph>

      <Heading size={600} marginBottom={8}>Accettazione</Heading>
      <Paragraph size={400} marginBottom={12}>
        Accedendo e utilizzando il sito accetti i presenti termini. Se non accetti, non usare il servizio.
      </Paragraph>

      <Heading size={600} marginBottom={8}>Servizi e uso consentito</Heading>
      <Paragraph size={400} marginBottom={12}>
        Il sito fornisce strumenti di gestione di dati, comunicazioni interne e caricamento documenti. L'uso è riservato a utenti autorizzati; è vietato l'uso illecito o che violi i diritti di terzi.
      </Paragraph>

      <Heading size={600} marginBottom={8}>Account e sicurezza</Heading>
      <UnorderedList marginBottom={12}>
        <ListItem>Gli utenti sono responsabili della riservatezza delle credenziali di accesso, che vengono fornite dall'utente con il livello di accesso più alto.</ListItem>
        <ListItem>Casa Letizia può sospendere o rimuovere account che violano i termini.</ListItem>
      </UnorderedList>

      <Heading size={600} marginBottom={8}>Contenuti caricati</Heading>
      <Paragraph size={400} marginBottom={12}>
        Sei responsabile dei contenuti che carichi. Non caricare dati sensibili senza autorizzazione; se il servizio richiede dati sensibili, vengono segnalati in modo specifico nella Privacy.
      </Paragraph>

      <Heading size={600} marginBottom={8}>Responsabilità</Heading>
      <Paragraph size={400} marginBottom={12}>
        Casa Letizia fornisce il servizio "as is"; nonostante gli sforzi per mantenere il servizio disponibile e sicuro, non si garantisce assenza di errori. La responsabilità è limitata nei limiti consentiti dalla legge.
      </Paragraph>

      <Heading size={600} marginBottom={8}>Modifiche</Heading>
      <Paragraph size={400} marginBottom={12}>
        Ci riserviamo il diritto di modificare i termini; le modifiche saranno pubblicate su questa pagina con aggiornamento della data.
      </Paragraph>

      <Heading size={600} marginBottom={8}>Legge applicabile</Heading>
      <Paragraph size={400} marginBottom={12}>
        I presenti termini si intendono regolati dalla legge italiana. Per controversie è competente il foro indicato nella normativa vigente salvo disposizioni imperative.
      </Paragraph>
      
      <Heading size={600} marginBottom={8}>Note</Heading>
      <Paragraph size={400} marginBottom={12}>
        Versione della Policy: 1.0 del 04/11/2025
      </Paragraph>
      <Paragraph size={400} marginBottom={12}>
        Il fornitore del sito web non è responsabile della redazione o conformità legale delle policy (Privacy, Cookie, Termini e Condizioni), che restano a carico del committente. Il fornitore si limiterà alla loro integrazione tecnica sul sito.
      </Paragraph>

    </Pane>
  );
};

export default TermsPage;
